// Store
import { Selector, State, StateContext, Action, Store } from '@ngxs/store';
import {
	SetNexsysOrderListFilters,
	SetNexsysOrderLogInfo,
	SetOrderMonitorOrigin
} from './actions/nexsys-monitor.actions';
// Models
import {
	NexsysMonitorStateModel,
	NexsysOrder,
	NexsysOrderListFilters
} from './model/nexsys-monitor-state.model';
import { Injectable } from '@angular/core';

@State<NexsysMonitorStateModel>({
	name: 'nexsysMonitor',
	defaults: {},
	children: []
})
@Injectable()
export class NexsysMonitorState {
	constructor(private store: Store) {}

	/**
	 * Get Feature Quality State Model.
	 * @param state: GlobalConfigurationStateModel
	 */
	@Selector()
	static getNexsysMonitor(state: NexsysMonitorStateModel): NexsysMonitorStateModel {
		return state;
	}

	/**
	 * Get product list appScope State Model.
	 * @param state: GlobalConfigurationStateModel
	 */
	@Selector()
	static getNexsysOrderInfoBase(state: NexsysMonitorStateModel): NexsysOrder {
		return state.nexsysOrderLog;
	}

	/**
	 * Get order lists filters
	 * @param state: GlobalConfigurationStateModel
	 */
	@Selector()
	static getNexsysOrderListFilters(state: NexsysMonitorStateModel): NexsysOrderListFilters {
		return state.nexsysOrderListFilters;
	}

	/**
	 * Get order monitor origin
	 * @param state: GlobalConfigurationStateModel
	 */
	@Selector()
	static getOrderMonitorOrigin(state: NexsysMonitorStateModel): string {
		return state.origin;
	}

	/**
	 * Save the current selected section
	 * @param ctx
	 * @param payload
	 */
	@Action(SetNexsysOrderLogInfo)
	setNexsysOrderLogInfo(
		ctx: StateContext<NexsysMonitorStateModel>,
		{ nexsysOrderLog }: SetNexsysOrderLogInfo
	): any {
		const state = ctx.getState();
		ctx.patchState({
			...state,
			nexsysOrderLog
		});
	}

	/**
	 * Save the current order list filters
	 * @param ctx
	 * @param payload
	 */
	@Action(SetNexsysOrderListFilters)
	setNexsysOrderListFilters(
		ctx: StateContext<NexsysMonitorStateModel>,
		{ nexsysOrderListFilters }: SetNexsysOrderListFilters
	): any {
		const state = ctx.getState();

		ctx.patchState({
			...state,
			nexsysOrderListFilters
		});
	}

	/**
	 * Save the current origin log
	 * @param ctx
	 * @param payload
	 */
	@Action(SetOrderMonitorOrigin)
	setOrderMonitorOrigin(
		ctx: StateContext<NexsysMonitorStateModel>,
		{ origin }: SetOrderMonitorOrigin
	): any {
		const state = ctx.getState();

		ctx.patchState({
			...state,
			origin
		});
	}
}
